import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { deleteUser } from '../actions';
import {
  getUser,
  currentUserNumberQuestionsAnsweredIncorrectly,
  currentUserNumberQuestionsAnsweredCorrectly,
  totalNumberQuestions,
} from '../selectors';

const UserRow = ({
  user: {
    firstName,
    lastName,
    email,
    group,
    city,
    eventDay,
  },
  numIncorrect,
  numCorrect,
  totalNumQuestions,
  userUID,
  dispatch,
}) => (
  <tr className="flext items-center justify-between h3 bb b--light-gray">
    <td className="w-10 pr2">
      {`${firstName} ${lastName}`}
    </td>
    <td className="w-10 mw4 pr2">{email}</td>
    <td className="w-10 mw4 pr2">{city}</td>
    <td className="w-10 mw2 pr2">{group}</td>
    <td className="w-10 mw4 pr2">{eventDay}</td>
    <td className="w-20 pr0">
      <div className="Button-admin correct b tc db ph2 pt1 pb2 mr2 w3 mw3">
        <i className="material-icons-xs">check_circle</i>
        {numCorrect}
      </div>
      <div className="Button-admin incorrect b tc db ph2 pt1 pb2 mr2 w3 mw3">
        <i className="material-icons-xs">cancel</i>
        {numIncorrect}
      </div>
      <div className="Button-admin gray b tc db ph2 pt1 pb2 w3 mw3">
        <i className="material-icons-xs">help</i>
        {totalNumQuestions - (numCorrect + numIncorrect)}
      </div>
    </td>
    <td className="w-10 mw2 pr2">
      <button type="button" className="Button-admin incorrect b tc db ph2 pt1 pb2 mr2 w3 mw3" onClick={(e) => {
        e.preventDefault();
        if (window.confirm(`Are you sure you want to delete the user "${firstName} ${lastName}"?`)) {
          dispatch(deleteUser(userUID))
        }
      }}>Delete</button>
    </td>
  </tr>
);

UserRow.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    group: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    eventDay: PropTypes.string.isRequired,
  }).isRequired,
  userUID: PropTypes.string.isRequired,
  numIncorrect: PropTypes.number.isRequired,
  numCorrect: PropTypes.number.isRequired,
  totalNumQuestions: PropTypes.number.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    user: getUser(state, ownProps),
    numIncorrect: currentUserNumberQuestionsAnsweredIncorrectly(state, ownProps),
    numCorrect: currentUserNumberQuestionsAnsweredCorrectly(state, ownProps),
    totalNumQuestions: totalNumberQuestions(state, ownProps),
  };
}

export default connect(mapStateToProps)(UserRow);



// WEBPACK FOOTER //
// ./src/components/UserRow.js